import React, { useEffect, useRef, useState } from "react";
import GlobalHeader from "../../../components/header";
import Footer from "../../../components/footer";
import {
  Backdrop,
  Box,
  CircularProgress,
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import GalleryProfile from "../../../components/GalleryProfile";
import { LoadingButton } from "@mui/lab";
import useSnack from "../../../hooks/useSnack";
import useApi from "../../../hooks/useApi";
import AddAPhotoIcon from "@mui/icons-material/AddAPhoto";
import AbcIcon from "@mui/icons-material/Abc";
import AddIcon from "@mui/icons-material/Add";
import EuroIcon from "@mui/icons-material/Euro";
import { Edit, KingBed } from "@mui/icons-material";
import AspectRatioIcon from "@mui/icons-material/AspectRatio";
import BathtubIcon from "@mui/icons-material/Bathtub";
import { useParams } from "react-router-dom";
import TitleIcon from "../../../components/TitleIcon";
import EditIcon from "@mui/icons-material/Edit";
import SnackAlert from "../../../components/SnackAlert";

function EditProperty() {
  // DATA
  const [mainData, setMainData] = useState({ gallery_edit: [] });
  const [galleryImages, setGalleryImages] = useState();
  const [previewPicture, setPreviewPicture] = useState(false);
  const [messageCheck, setMessageCheck] = useState(false);
  const purpose_list = ["Venta", "Arriendo"];
  const types_list = ["Casa", "Apartamento"];
  const [photoProfileEdit, setPhotoProfileEdit] = useState("");

  // UTILS
  const [isLoading, setIsLoading] = useState(false);
  const fileInputPhoto = useRef(null);
  const fileGallery = useRef(null);
  const { loadApi, loadingApi } = useApi();
  const { msgSB, openSB, showSnack, typeSB } = useSnack();
  const [backdropLoading, setBackdropLoading] = useState(false);

  const params = useParams();

  const handlerAddImage = (event) => {
    const selectedFile = event.target.files[0];

    // EVITAR DUPLICADOS
    const isDuplicate = galleryImages.filter(
      (x) => x.name === selectedFile.name
    );

    if (isDuplicate.length !== 0) {
      fileGallery.current.value = "";
      showSnack("Error, el archivo ya existe");
      return;
    }
    setMainData({
      ...mainData,
      gallery_edit: [...(mainData.gallery_edit || []), selectedFile],
    });

    // CODIGO PARA AÑADIR IMAGEN DE PREVISUALIZACION
    if (selectedFile) {
      const reader = new FileReader();
      reader.onload = (e) => {
        setGalleryImages([
          ...galleryImages,
          { url: e.target.result, name: selectedFile.name },
        ]);
      };
      reader.readAsDataURL(selectedFile);
    }
    fileGallery.current.value = "";
  };

  const handlerChangePreviewImage = (e) => {
    const file = e.target.files[0];
    setPhotoProfileEdit(file);
    if (file) {
      setMainData({ ...mainData, photo_profile: file });
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviewPicture(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const GetProperty = async () => {
    setBackdropLoading(true);
    loadApi("superadmin/states/" + params.id, true, "get")
      .then((response) => {
        setGalleryImages(response.data.gallery);
        setMainData(response.data);
      })
      .catch((e) => {
        showSnack(e.message);
      })
      .finally(() => setBackdropLoading(false));
  };

  const areThereEmptyFields = (data) => {
    let result = false;

    const fieldsString = [
      "name",
      "information",
      "price",
      "purpose_use",
      "type",
      "location",
      "m2",
      "bedrooms",
      "bathrooms",
    ];

    for (const field of fieldsString) {
      if (
        data.hasOwnProperty(field) &&
        data[field].trim &&
        data[field].trim() === ""
      ) {
        result = true;
      }
    }

    if (Array.isArray(data.gallery) && data.gallery.length === 0) {
      result = true;
    }
    // if (Array.isArray(data.gallery_edit) && data.gallery_edit.length === 0) {
    //   result = true;
    // }

    if (data.hasOwnProperty("photo_profile") && data.photo_profile === null) {
      result = true;
    }
    // if (data.hasOwnProperty("photo_profile_edit") && data.photo_profile_edit === null) {
    //   result = true;
    // }

    return result;
  };

  const EditProperty = () => {
    let data = {
      photo_profile_edit: photoProfileEdit,
      photo_profile: mainData.photo_profile,
      name: mainData.name,
      information: mainData.information,
      price: mainData.price,
      purpose_use: mainData.purpose_use,
      type: mainData.type,
      location: mainData.location,
      m2: mainData.m2,
      bedrooms: mainData.bedrooms,
      bathrooms: mainData.bathrooms,
      gallery: mainData.gallery,
      gallery_edit: mainData.gallery_edit,
    };

    const thereAreEmptyFields = areThereEmptyFields(data);
    if (thereAreEmptyFields) {
      showSnack("Debe llenar todos los campos");
      return;
    }

    setIsLoading(true);
    loadApi(`superadmin/states/${params.id}`, true, "put", { ...data }, true)
      .then(() => {
        showSnack("Inmueble actualizado con éxito", "success");
      })
      .catch((e) => showSnack(e.message))
      .finally(() => {
        setIsLoading(false);
      });
  };

  const formatNumberWithDots = (number) => {
    return number.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  };
  const handleChange = (value) => {
    const rawValue = value.replace(/\./g, "");

    return rawValue;
  };

  useEffect(() => {
    GetProperty();
  }, []);

  return (
    <>
      <GlobalHeader />
      <Stack
        sx={{
          backgroundColor: { xs: "none", md: "white" },
          width: { xs: "100vw", md: "80vw", lg: "75vw" },
          minHeight: "calc(100vh - 120px)",
          marginInline: "auto",
          pt: 4,
        }}
      >
        <Stack px={{ xs: 2, md: 4 }}>
          {mainData?.name && (
            <>
              <TitleIcon
                title="Editar inmueble"
                icon={<EditIcon fontSize="large" />}
              />
              <Stack flexDirection={{ xs: "column", md: "row" }} gap={5} mb={4}>
                <Stack
                  justifyContent="center"
                  alignItems="center"
                  component="article"
                  sx={{
                    boxShadow: previewPicture
                      ? "-6px 5px 8px -1px rgba(0,0,0,0.31)"
                      : "none",
                    cursor: "pointer",
                    width: { xs: "100%", md: "40%" },
                    height: { xs: 250, md: 270 },
                    border: "1px solid gray",
                    borderRadius: 2,
                  }}
                  onClick={() => fileInputPhoto.current.click()}
                >
                  {mainData.photo_profile[0].url ? (
                    <img
                      width="100%"
                      height="100%"
                      style={{ objectFit: "cover", borderRadius: 8 }}
                      src={previewPicture || mainData.photo_profile[0].url}
                    />
                  ) : (
                    <AddAPhotoIcon
                      sx={{ color: "#87878757" }}
                      fontSize="large"
                    />
                  )}
                  <input
                    style={{ display: "none" }}
                    type="file"
                    accept=".jpg, .png, .jpeg, .webp"
                    ref={fileInputPhoto}
                    onChange={handlerChangePreviewImage}
                  />
                </Stack>
                <Stack
                  gap={1.5}
                  sx={{
                    width: { xs: "100%", md: "60%" },
                  }}
                >
                  <Typography component="h3" variant="h6">
                    Básico
                  </Typography>
                  <TextField
                    label="Título"
                    fullWidth
                    value={mainData.name}
                    onChange={({ target }) => {
                      setMainData({
                        ...mainData,
                        name: target.value,
                      });
                    }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <AbcIcon />
                        </InputAdornment>
                      ),
                    }}
                  />
                  <TextField
                    label="Ubicación de inmueble"
                    value={mainData.location}
                    onChange={({ target }) => {
                      setMainData({
                        ...mainData,
                        location: target.value,
                      });
                    }}
                    fullWidth
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <AbcIcon />
                        </InputAdornment>
                      ),
                    }}
                  />
                  <TextField
                    label="Precio"
                    type="text"
                    value={formatNumberWithDots(mainData.price)}
                    fullWidth
                    onChange={({ target }) => {
                      let result = handleChange(target.value);
                      if (/^\d*$/.test(result)) {
                        setMainData({
                          ...mainData,
                          price: result,
                        });
                      }
                    }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <EuroIcon />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Stack>
              </Stack>
              <Stack>
                <Typography component="h3" variant="h6" mb={2}>
                  Información de inmueble
                </Typography>
                <Box
                  display="flex"
                  flexDirection={{ xs: "column", md: "row" }}
                  justifyContent="space-between"
                  gap={3}
                  mb={2}
                >
                  <FormControl sx={{ width: "100%" }}>
                    <InputLabel id="demo-multiple-name-label">
                      Tipo de inmueble
                    </InputLabel>
                    <Select
                      labelId="demo-multiple-name-label"
                      id="demo-multiple-name"
                      value={mainData.type}
                      onChange={({ target }) => {
                        setMainData({
                          ...mainData,
                          type: target.value,
                        });
                      }}
                      input={<OutlinedInput label="Tipo de inmueble" />}
                    >
                      {(types_list || []).map((name) => (
                        <MenuItem key={name} value={name}>
                          {name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  <FormControl sx={{ width: "100%" }}>
                    <InputLabel id="demo-multiple-name-label">
                      Propósito de uso
                    </InputLabel>
                    <Select
                      labelId="demo-multiple-name-label"
                      id="demo-multiple-name"
                      value={mainData.purpose_use}
                      onChange={({ target }) => {
                        setMainData({
                          ...mainData,
                          purpose_use: target.value,
                        });
                      }}
                      input={<OutlinedInput label="Propósito de uso" />}
                    >
                      {(purpose_list || []).map((name) => (
                        <MenuItem key={name} value={name}>
                          {name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Box>
                <Box
                  display="flex"
                  flexDirection={{ xs: "column", md: "row" }}
                  justifyContent="space-between"
                  gap={3}
                  mb={2}
                >
                  <TextField
                    label="Número de habitaciones"
                    value={mainData.bedrooms}
                    onChange={({ target }) => {
                      setMainData({
                        ...mainData,
                        bedrooms: target.value,
                      });
                    }}
                    fullWidth
                    type="number"
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <KingBed />
                        </InputAdornment>
                      ),
                    }}
                  />
                  <TextField
                    label="Número de baños"
                    value={mainData.bathrooms}
                    onChange={({ target }) => {
                      setMainData({
                        ...mainData,
                        bathrooms: target.value,
                      });
                    }}
                    type="number"
                    fullWidth
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <BathtubIcon />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Box>
                <Box
                  mb={4}
                  display="flex"
                  flexDirection={{ xs: "column", md: "row" }}
                  justifyContent="space-between"
                  gap={3}
                >
                  <TextField
                    label="Descripción del inmueble"
                    fullWidth
                    value={mainData.information}
                    onChange={({ target }) => {
                      setMainData({
                        ...mainData,
                        information: target.value,
                      });
                    }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <AbcIcon />
                        </InputAdornment>
                      ),
                    }}
                  />
                  <TextField
                    label="Metros Cuadrados"
                    fullWidth
                    value={mainData.m2}
                    onChange={({ target }) => {
                      setMainData({
                        ...mainData,
                        m2: target.value,
                      });
                    }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <AspectRatioIcon />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Box>
              </Stack>
              <Stack mb={2}>
                <Stack flexDirection="row" alignItems="center" mb={2}>
                  <Typography component="h3" variant="h6" mr={2}>
                    Imágenes del inmueble
                  </Typography>
                  <IconButton
                    onClick={() => fileGallery.current.click()}
                    size="small"
                    sx={{
                      backgroundColor: "primary.main",
                      color: "white",
                      "&:hover": { backgroundColor: "primary.300" },
                    }}
                  >
                    <AddIcon fontSize="small" />
                  </IconButton>

                  <input
                    onChange={handlerAddImage}
                    style={{ display: "none" }}
                    type="file"
                    accept=".jpg, .png, .jpeg, .webp"
                    ref={fileGallery}
                  />
                </Stack>
                <GalleryProfile
                  setGalleryImages={setGalleryImages}
                  data={galleryImages}
                  mainData={mainData}
                  setDataProfile={setMainData}
                />
              </Stack>
              <LoadingButton
                type="submit"
                loading={isLoading}
                onClick={EditProperty}
                sx={{
                  width: "fit-content",
                  mb: 5,
                  px: 3,
                  py: 1.5,
                  borderRadius: 5,
                  color: "white",
                  marginInline: "auto",
                  "&:hover": {
                    backgroundColor: "primary.300",
                  },
                }}
              >
                ACTUALIZAR INMUEBLE
              </LoadingButton>
            </>
          )}
        </Stack>
      </Stack>
      <Footer />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={backdropLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <SnackAlert openSB={openSB} typeSB={typeSB} msgSB={msgSB} />
    </>
  );
}

export default EditProperty;
